export default "__VITE_ASSET__6DFhlgCd__"